import { render, staticRenderFns } from "./app.vue?vue&type=template&id=2deaeb05&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=2deaeb05&prod&lang=scss&"
import style1 from "./app.vue?vue&type=style&index=1&id=2deaeb05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deaeb05",
  null
  
)

export default component.exports